import React from "react";
import { Link } from "react-router-dom";
import i18n from "i18next";
import {
	clearRgistrationInfo,
	loginUser,
	loginUserClear,
	setEnvironment,
	logoutUser
} from "../../../common/actions/userAccount";
import { connect } from "react-redux";
import { Colors } from "../../../theme";
import { withTranslation } from "react-i18next";
import "../../../../node_modules//bootstrap/dist/css/bootstrap.min.css";
import { RegisterFooter, RegisterHeader } from "../../CommonComponents";
import "../../../../node_modules/font-awesome/css/font-awesome.min.css";
import "../../Styles/app.css";
import "../Registration/Styles/style.css";
import "./landing.css";
import "../Registration/Styles/theme-responsive.css";
import { createLoadingSelector } from "../../../common/reducers/selectors";
import { getLanguageCode, nextField } from "../../../helper/utility";
const loadingSelector = createLoadingSelector(["login_user"]);

class LandingPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			userName: "",
			password: "",
			env: "prod",
			userNameError: "",
			userPassError: "",
			hidePassword: true,
			ServerError: "",
		};
		this.props.doLogoutUser()
	}

	setPasswordVisibility = () => {
		this.setState({ hidePassword: !this.state.hidePassword });
	};

	handleSubmit = () => {
		let { userName, password } = this.state;
		let { env } = this.state;
		const { doSetEnvironment } = this.props;
		var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		let isValid = reg.test(userName);
		if (reg.test(userName) === false) {
			this.setState({
				userNameError: `${this.props.t("regAcctScr-emailError")}`,
			});
			return;
		}
		if (password === null || password === "") {
			this.setState({
				userPassError: `${this.props.t("loginScreen-passwordError")}`,
			});
			return;
		}
		if (userName.includes(".staging")) {
			env = "staging";
		} else if (userName.includes(".develop")) {
			env = "develop";
		} else if (userName.includes(".localhost")) {
			env = "localhost";
		}else {
			env = "prod";
		}
		this.setState({ env }, () => {
			if (env === "staging") {
				doSetEnvironment({ env: "staging", callback: this.processLogin });
			} else if (env === "develop") {
				doSetEnvironment({ env: "develop", callback: this.processLogin });
			} else if (env === "localhost") {
				doSetEnvironment({ env: "localhost", callback: this.processLogin });
			} else {
				doSetEnvironment({ env: "prod", callback: this.processLogin });
			}
		});
	};

	processLogin = () => {
		const { doLogin, doClearRgistrationInfo } = this.props;
		let { userName, password, env } = this.state;

		if (userName.includes(".staging")) {
			userName = userName.replace(".staging", "");
		} else if (userName.includes(".develop")) {
			userName = userName.replace(".develop", "");
		}else if (userName.includes(".localhost")) {
			userName = userName.replace(".localhost", "");
		}

		doClearRgistrationInfo();
		doLogin({
			email: userName,
			password: password,
			locale: getLanguageCode(),
			env,
		});
	};

	handleUserChange = ({ target: { value: userName } }) =>
		this.setState({ userName, userNameError: "", ServerError: "" });
	handlePasswordChange = ({ target: { value: password } }) =>
		this.setState({ password, userPassError: "", ServerError: "" });

	componentDidUpdate() {
		const { userLoginInfo, error, doLoginClear } = this.props;

		if (error) {
			this.setState({ ServerError: error.Message });
			doLoginClear();
		} else if (userLoginInfo != null) {
			setTimeout(() => {
				this.props.history.replace("/childManagement");
			}, 1000)
		}
	}

	render() {
		const {
			userName,
			password,
			userNameError,
			userPassError,
			hidePassword,
			ServerError,
		} = this.state;
		const { isFetching, doClearRgistrationInfo } = this.props;
		return (
			<section className="registration">
				<div className="wrapper">
					<div className="landing-wrapper">
						<div className="row h-100vh nomargin-row">
							<RegisterHeader />
							<div className="col-sm-12 col-md-5 col-lg-5 col-xl-4 sidebar-col">
								<div className="sidebar-wrapper">
									<form className="form-style1">
										<div className="title-sect mb-40">
											<h3 className="title-3">
												{this.props.t("loginScreen-lets-get-started")}
											</h3>
											<p className="helptext">
												{this.props.t(
													"loginScreen-please-enter-email-password"
												)}
											</p>
										</div>

										<div className="form-group">
											<input
												type="email"
												className={`form-control ${userNameError !== "" ? "input-error" : null
													}`}
												placeholder={this.props.t("loginScreen-email")}
												name="username"
												value={userName}
												onChange={this.handleUserChange}
												onKeyPress={(event) => nextField(event)}
											/>
											<i className="far fa-user-circle userIcon"></i>
											<span className="error" id="error">
												{" "}
												{userNameError}
											</span>
										</div>

										<div className="form-group">
											<input
												type={hidePassword ? "password" : "text"}
												className={`form-control ${userPassError !== "" ? "input-error" : null
													}`}
												placeholder={this.props.t("loginScreen-password")}
												value={password}
												onChange={this.handlePasswordChange}
												onKeyPress={(event) => { if (event.key === 'Enter') this.handleSubmit() }}
												name="password"
											/>
											<i
												onClick={this.setPasswordVisibility}
												className={
													hidePassword
														? "far fa-eye togglePassword"
														: "far fa-eye-slash togglePassword1"
												}
											></i>
											<span className="error" id="error">
												{" "}
												{userPassError}
											</span>
										</div>

										<div className="form-group mb-40 ">
											<div className="row">
												<div className="accept-terms-label col col-xs-6">
													<div className="box-checkbox">
														<input
															type="checkbox"
															id="accept_terms"
															name="accept_terms"
														/>
														<label htmlFor="accept_terms"></label>
														<span className="Remember-me">
															{this.props.t("loginScreen-remember-me")}
														</span>
													</div>
												</div>
												<div className="col -xs-6 text-right">
													<Link
														className="Button-Label"
														to="/forgotPassword"
													>
														{this.props.t("loginScreen-ForgotPassword")}
													</Link>
												</div>
											</div>
										</div>
										<span className="error" id="error">
											{" "}
											{ServerError}
										</span>
										<div className="form-group">
											<button
												type="button"
												className="btn btn-primary"
												onClick={() => { this.handleSubmit() }}

											>
												{" "}
												{isFetching ? (
													<i className="fas fa-sync-alt fa-spin"></i>
												) : null}{" "}
												&nbsp; {this.props.t("loginScreen-login")}
											</button>
										</div>
									</form>

									<div className="createAccount">
										<div className="form-group">
											<p className="New-to-Pikmykid">
												{this.props.t("loginScreen-new-to-pikmykid")}
											</p>
											<p className="createAccountText">
												{this.props.t(
													"loginScreen-you-can-create-new-acoount-here"
												)}
											</p>
										</div>
										<div className="form-group">
											<button
												type="button"
												className="btn buttonSecondary"
												onClick={() => {
													doClearRgistrationInfo();
													this.props.history.push("/registerName");
												}}
											>
												{this.props.t("loginScreen-create-account")}
											</button>
										</div>
									</div>
									<RegisterFooter />
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}

function mapStateToProps(state) {
	return {
		userLoginInfo: state.userAccount.userLoginInfo,
		isFetching: loadingSelector(state),
		error: state.userAccount.error,
		registeredEmail: state.userAccount.registeredEmail,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		doClearRgistrationInfo: () => dispatch(clearRgistrationInfo()),
		doLogin: (data) => dispatch(loginUser(data)),
		doLoginClear: () => dispatch(loginUserClear()),
		doSetEnvironment: (data) => dispatch(setEnvironment(data)),
		doLogoutUser: () => dispatch(logoutUser()),
	};
}
export default withTranslation()(
	connect(mapStateToProps, mapDispatchToProps)(LandingPage)
);
